import React from 'react';
import English from './English';
import Indonesia from './Indonesia';

const Alto = props => {
  switch (props.language) {
    case 'EN':
      return <English />;
    case 'ID':
      return <Indonesia />;
  }
};

export default Alto;
